import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import InitialSetupForm from './InitialSetupForm';
import { useAuth } from '../../contexts/AuthContext';
import { buildApiUrl } from '../../config/api';

const InitialSetupFlow = () => {
  const navigate = useNavigate();
  const { getAuthHeaders } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check if user already completed setup (only once on mount)
    let mounted = true;
    
    const checkSetupStatus = async () => {
      try {
        const response = await fetch(buildApiUrl('/auth/initial-setup/status'), {
          method: 'GET',
          headers: getAuthHeaders(),
        });

        if (response.ok && mounted) {
          const data = await response.json();
          
          // If setup is complete, redirect to dashboard (always precision mode)
          if (!data.needsSetup) {
            navigate('/wealth-dashboard', { replace: true });
          }
        }
      } catch (err) {
        if (mounted) {
          console.error('Error checking setup status:', err);
          setError('Failed to check setup status');
        }
      }
    };

    checkSetupStatus();
    
    return () => {
      mounted = false;
    };
  }, []);

  const handleSetupSubmit = async (setupData) => {
    setLoading(true);
    setError(null);

    try {
      console.log('[InitialSetupFlow] Saving setup data:', setupData);
      const response = await fetch(buildApiUrl('/auth/initial-setup'), {
        method: 'POST',
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(setupData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to save setup data');
      }

      const result = await response.json();
      console.log('[InitialSetupFlow] Setup data saved successfully:', result);
      console.log('[InitialSetupFlow] Redirecting to wealth dashboard');

      // Navigate directly to dashboard (always precision mode)
      navigate('/wealth-dashboard', { replace: true });
    } catch (err) {
      console.error('[InitialSetupFlow] Error saving setup data:', err);
      setError(err.message || 'Failed to save setup data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Mode selection removed - always use precision mode

  return (
    <div className="min-h-screen bg-background flex items-center justify-center py-12">
      {error && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 bg-destructive text-destructive-foreground px-4 py-2 rounded-md shadow-lg">
          {error}
        </div>
      )}
      <InitialSetupForm 
        onSubmit={handleSetupSubmit} 
        loading={loading}
      />
    </div>
  );
};

export default InitialSetupFlow;

